module.exports = __webpack_public_path__ + "img/PaymentModal.33e5190f.png";